import { MainRoutes, RouteRoles } from "ui/common/router/MainRouter.types";
import { AppTab } from "./AppTabs.types";

export const APP_TABS: AppTab[] = [
    {
        label: "home",
        path: MainRoutes.MAIN,
        roles: RouteRoles.MAIN,
    },
    {
        label: "clients",
        path: MainRoutes.USERS,
        roles: RouteRoles.USERS,
    },
    {
        label: "transactions",
        path: MainRoutes.TRANSACTIONS,
        roles: RouteRoles.TRANSACTIONS,
    },
    {
        label: "programs",
        path: MainRoutes.PROGRAMS,
        roles: RouteRoles.PROGRAMS,
    },
    {
        label: "partners",
        path: MainRoutes.PARTNERS,
        roles: RouteRoles.PARTNERS,
    },
    {
        label: "myProgram",
        path: MainRoutes.MY_PROGRAM,
        roles: RouteRoles["MY-PROGRAM"],
    },
    {
        label: "myCommerce",
        path: MainRoutes.MY_PARTNER,
        roles: RouteRoles["MY-PARTNER"],
    },
    {
        label: "pointsOfSale",
        path: MainRoutes.POINTS_OF_SELL,
        roles: RouteRoles["POINTS-OF-SELL"],
    },
    {
        label: "orchestrator",
        path: MainRoutes.ORCHESTRATOR,
        roles: RouteRoles["ORCHESTRATOR"],
    },
    {
        label: "administratorsAndSecurity",
        path: MainRoutes.ADMINS_AND_SECURITY,
        roles: RouteRoles["ADMINS-AND-SECURITY"],
    },
    {
        label: "giftCards",
        path: MainRoutes.GIFTCARDS,
        roles: RouteRoles["GIFTCARDS"],
    },
];
